import gql from 'graphql-tag'

export default gql`
	query LocalQuery_getDiscountGroupNames($defaultNames: Boolean = true, $language: Int = 2) {
		getDiscountGroupNames(defaultNames: $defaultNames, language: $language) @client
	}
`
